<!-- Projects view -->
<template>
  <v-container fluid>
    <v-layout wrap v-for="data in projectPendings" :key="data.id">
      <v-flex xs1 />
      <v-flex xs10>
        <v-alert v-if="data.showed" prominent type="info">
          <v-row align="center">
            <v-col class="grow">Tiene una invitacion pendiente del proyecto {{ data.name }}</v-col>
            <v-col class="shrink">
              <v-btn @click="acceptProjectPending(data)">Aceptar</v-btn>
            </v-col>
            <v-col class="shrink">
              <v-btn @click="removeProjectPending(data)">Declinar</v-btn>
            </v-col>
            <v-col class="shrink">
              <p
                @click="data.showed = false"
                style="margin-top: 15px; margin-right: 17px; cursor: pointer;"
              >
                X
              </p>
            </v-col>
          </v-row>
        </v-alert>
      </v-flex>
      <v-flex xs1 />
    </v-layout>
    <!-- <v-row align="center" justify="space-around">
      <v-alert v-for="data in projectPendings" :key="data.id" type="info">
        Tiene una invitacion pendiente del proyecto {{ data.name }}
      </v-alert>
    </v-row> -->
    <v-row align="center" justify="space-around">
      <!-- TODO: THE CARD FOR THE LIST OF PROJECTS -->
      <v-col justify="center" cols="12">
        <v-container>
          <v-layout class="ml-10">
            <v-col cols="8">
              <v-row>
                <v-flex xs4>
                  <v-combobox
                    label="Filtrar por"
                    :items="filter_items"
                    v-model="filter_by"
                    @change="orderList()"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Buscar"
                    v-model="search_value"
                    @change="filterList()"
                  ></v-text-field>
                </v-flex>
              </v-row>
              <v-row aling="center" justify="center">
                <v-btn text small color="black" @click="cleanFilter"
                  >Limpiar Filtro</v-btn
                >
              </v-row>
            </v-col>
            <v-col cols="8">
              <v-flex xs4>
                <v-combobox
                  v-model="order_by"
                  label="Ordenar por"
                  :items="order_items"
                  @change="orderList()"
                />
              </v-flex>
            </v-col>
          </v-layout>
          <v-card>
            <v-tabs
              v-model="active"
              color="white"
              dark
              slider-color="cyan"
              @change="orderList()"
            >
              <v-tab
                class="white--text"
                style="width:100%;"
                v-for="tab in tabs"
                :key="tab"
                light
                ripple
                >{{ tab }}</v-tab
              >
              <v-tab-item v-for="tab in tabs" :key="tab">
                <v-row v-if="tab === 'Públicos'">
                  <v-card
                    style="width:100%;"
                    class="black--text py-12"
                    v-for="project in arrayOrder.slice(
                      first_index,
                      second_index
                    )"
                    v-bind:key="project.project_id"
                    max-height="1000"
                  >
                    <v-row align="center" justify="center">
                      <v-col cols="2">
                        <v-img
                          src="@/assets/checklist.svg"
                          style="margin-top: 20px;"
                          height="125px"
                          contain
                          @click="
                            changePage(project.project_id, project.visibility)
                          "
                        />
                      </v-col>
                      <v-col cols="7">
                        <div>
                          <div
                            style="cursor:pointer;"
                            class="mr-4 text-justify hyphens title"
                            v-on:click="
                              changePage(project.project_id, project.visibility)
                            "
                          >
                            <div v-if="project.title.length > 100">
                              {{ project.title.slice(0, 100) }}...
                            </div>
                            <div v-else>
                              {{ project.title }}
                            </div>
                          </div>
                          <div
                            v-if="typeof project.description !== 'undefined'"
                          >
                            <div v-if="project.description.length > 200">
                              {{ project.description.slice(0, 200) }}...
                            </div>
                            <div v-else>
                              {{ project.description }}
                            </div>
                          </div>
                          <div v-else>
                            {{ project.description }}
                          </div>
                          <div v-if="project.type">
                            {{ project.type }}
                          </div>
                          <div>
                            <div v-if="project.tags">
                              <div class="body-1" v-if="filterTag(project.tags) != '' ">
                                <v-icon size="15px">mdi-tag</v-icon>
                                {{ filterTag(project.tags) }}
                              </div>
                            </div>
                          </div>
                          <div class="font-size:12px">
                            <div v-if="typeof project.owner !== 'undefined'">
                              Creado por: {{ project.owner.full_name }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="2">
                        <div v-if="project.visibility === 'public'">
                          <v-icon>mdi-earth</v-icon>
                        </div>
                        <div v-else>
                          <v-icon>mdi-lock</v-icon>
                        </div>
                        <div>
                          <div v-if="project.funding" class="body-1">
                            <div v-if="project.funding.amount">
                              $ {{ project.funding.amount }}
                            </div>
                            <div v-else>$ 0</div>
                          </div>
                          <div v-else>$ 0</div>
                        </div>
                        <div class="body-1">
                          {{ project.contributors.length }} Members
                        </div>
                        <div v-if="project.remainig_days === 0">
                          Finalizado
                        </div>
                        <div v-else>
                          Faltan {{ project.remainig_days }} dias
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
                <v-row v-if="tab === 'Privados'">
                  <v-card
                    style="width:100%;"
                    class="black--text py-12"
                    v-for="project in arrayOrder.slice(
                      first_index,
                      second_index
                    )"
                    v-bind:key="project.project_id"
                    max-height="1000"
                  >
                    <v-row align="center" justify="center">
                      <v-col cols="2">
                        <v-img
                          src="@/assets/checklist.svg"
                          style="margin-top: 20px;"
                          height="125px"
                          contain
                          @click="
                            changePage(project.project_id, project.visibility)
                          "
                        />
                      </v-col>
                      <v-col cols="7">
                        <div>
                          <div
                            style="cursor:pointer;"
                            class="mr-4 text-justify hyphens title"
                            v-on:click="
                              changePage(project.project_id, project.visibility)
                            "
                          >
                            <div v-if="project.title.length > 100">
                              {{ project.title.slice(0, 100) }}...
                            </div>
                            <div v-else>
                              {{ project.title }}
                            </div>
                          </div>
                          <div
                            v-if="typeof project.description !== 'undefined'"
                          >
                            <div v-if="project.description.length > 200">
                              {{ project.description.slice(0, 200) }}...
                            </div>
                            <div v-else>
                              {{ project.description }}
                            </div>
                          </div>
                          <div v-else>
                            {{ project.description }}
                          </div>
                          <div>
                            <div v-if="project.type">
                              {{ project.type }}
                            </div>
                            <div v-else>
                              OTHER
                            </div>
                          </div>
                          <div>
                            <div v-if="project.tags">
                              <div class="body-1" v-if="filterTag(project.tags) != '' ">
                                <v-icon size="15px">mdi-tag</v-icon>
                                {{ filterTag(project.tags) }}
                              </div>
                            </div>
                          </div>
                          <div class="font-size:12px">
                            <div v-if="typeof project.owner !== 'undefined'">
                              Creado por: {{ project.owner.full_name }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="2">
                        <div v-if="project.visibility === 'public'">
                          <v-icon>mdi-earth</v-icon>
                        </div>
                        <div v-else>
                          <v-icon>mdi-lock</v-icon>
                        </div>
                        <div>
                          <div v-if="project.funding" class="body-1">
                            <div v-if="project.funding.amount">
                              $ {{ project.funding.amount }}
                            </div>
                            <div v-else>$ 0</div>
                          </div>
                          <div v-else>$ 0</div>
                        </div>
                        <div class="body-1">
                          {{ project.contributors.length }} Members
                        </div>
                        <div v-if="project.remainig_days === 0">
                          Finalizado
                        </div>
                        <div v-else>
                          Faltan {{ project.remainig_days }} dias
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
                <v-row v-if="tab === 'Recomendados'">
                  <v-card
                    style="width:100%;"
                    class="black--text py-12"
                    v-for="project in arrayOrder.slice(
                      first_index,
                      second_index
                    )"
                    v-bind:key="project.project_id"
                    max-height="1000"
                  >
                    <v-row align="center" justify="center">
                      <v-col cols="2">
                        <v-img
                          src="@/assets/checklist.svg"
                          style="margin-top: 20px;"
                          height="125px"
                          contain
                          @click="
                            changePage(project.project_id, project.visibility)
                          "
                        />
                      </v-col>
                      <v-col cols="7">
                        <div>
                          <div
                            style="cursor:pointer;"
                            class="mr-4 text-justify hyphens title"
                            v-on:click="
                              changePage(project.project_id, project.visibility)
                            "
                          >
                            <div v-if="project.title.length > 100">
                              {{ project.title.slice(0, 100) }}...
                            </div>
                            <div v-else>
                              {{ project.title }}
                            </div>
                          </div>
                          <div
                            v-if="typeof project.description !== 'undefined'"
                          >
                            <div v-if="project.description.length > 200">
                              {{ project.description.slice(0, 200) }}...
                            </div>
                            <div v-else>
                              {{ project.description }}
                            </div>
                          </div>
                          <div v-else>
                            {{ project.description }}
                          </div>
                          <div>
                            <div v-if="project.type">
                              {{ project.type }}
                            </div>
                            <div v-else>
                              OTHER
                            </div>
                          </div>
                          <div>
                            <div v-if="project.tags">
                              <div class="body-1" v-if="filterTag(project.tags) != '' ">
                                <v-icon size="15px">mdi-tag</v-icon>
                                {{ filterTag(project.tags) }}
                              </div>
                            </div>
                          </div>
                          <div v-if="!project.tags">  </div>
                          <div class="font-size:12px">
                            <div v-if="typeof project.owner !== 'undefined'">
                              Creado por: {{ project.owner.full_name }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="2">
                        <div v-if="project.visibility === 'public'">
                          <v-icon>mdi-earth</v-icon>
                        </div>
                        <div v-else>
                          <v-icon>mdi-lock</v-icon>
                        </div>
                        <div>
                          <div v-if="project.funding" class="body-1">
                            <div v-if="project.funding.amount">
                              $ {{ project.funding.amount }}
                            </div>
                            <div v-else>$ 0</div>
                          </div>
                          <div v-else>$ 0</div>
                        </div>
                        <div class="body-1">
                          {{ project.contributors.length }} Members
                        </div>
                        <div v-if="project.remainig_days === 0">
                          Finalizado
                        </div>
                        <div v-else>
                          Faltan {{ project.remainig_days }} dias
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-container>
        <v-layout wrap>
          <v-flex xs8>
            <v-pagination
              v-model="page"
              class="my-4"
              :length="length_page"
              total-visible="7"
              @next="getCorrectList(page)"
              @previous="getCorrectList(page)"
            />
          </v-flex>
          <v-flex xs2>
            <v-combobox
              v-model="len_list"
              label="Proyectos por página"
              :items="items"
              @change="changeLenList"
            />
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>

    <!--SnackBar for errors-->
    <v-snackbar v-model="snackbar" :right="true" :timeout="3000" :top="true">
      Elija un proyecto para continuar
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { auth, firestore } from "firebase";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      active: null,
      originalPendingsProjects: [],
      color: "#EBF5FB",
      arrayOrder: [],
      len_list: 10,
      items: [5, 10, 20, 50],
      order_by: "Título A-Z",
      order_items: [
        "Título A-Z",
        "Título Z-A",
        "Propietario A-Z",
        "Propietario Z-A",
        "Tipo A-Z",
        "Tipo Z-A"
      ],
      filter_items: [
        "Propietario",
        "Título",
        "Dias Restantes",
        "Tipo",
        "Etiquetas",
        "Sin Filtro"
      ],
      length_page: 0,
      disable: false,
      value: null,
      first_index: 0,
      second_index: 0,
      keyproject: 0,
      snackbar: false,
      filter_by: "",
      search_value: "",
      usuario: "",
      page: 1,
      projectPendings: [],
      tab: "Públicos",
      tabs: []
    };
  },
  computed: {
    ...mapGetters("projects", [
      "getPublicsProjects",
      "getPrivateProjects",
      "getRecommendedProjects",
      "getPendingProjects"
    ]),
  },
  mounted() {
    if (auth().currentUser !== null && this.projectPendings.length === 0) {
      if (!this.getPendingProjects) {
        const idUser = auth().currentUser.uid;

        firestore()
          .collection("User")
          .doc(idUser)
          .get()
          .then(result => {
            const data = result.data();

            if (data.projectsPending) {
              this.originalPendingsProjects = data.projectsPending;
              data.projectsPending.forEach(pj =>
                this.projectPendings.push({
                  ...pj,
                  showed: true
                })
              );
            }
          });
      } else this.projectPendings = this.getPendingProjects;
    }
    this.filter_by = "Título";
    this.tabs = auth().currentUser
      ? ["Públicos", "Privados", "Recomendados"]
      : ["Públicos"];
    this.listPublicProjects();
    this.listPrivateProject();
    this.listRecommended();
  },
  watch: {
    getPublicsProjects: function() {
      this.orderList();
      this.second_index = this.page * this.len_list;
      this.length_page = Math.ceil(
        this.getPublicsProjects.length / this.len_list
      );
      // eslint-disable-next-line no-console
    },
    getPrivateProjects: function() {
      this.orderList();
      this.second_index = this.page * this.len_list;
    },
    page: function(page) {
      this.getCorrectList(page);
    }
  },
  methods: {
    ...mapActions("projects", [
      "listRecommended",
      "listPublicProjects",
      "listPrivateProject"
    ]),
    removeProjectPending(project) {
      this.projectPendings.splice(this.projectPendings.indexOf(project), 1);
      // eslint-disable-next-line no-console
      console.log(this.projectPendings)
    },
    acceptProjectPending(project) {
      const proID =project.id;
      const idUser = auth().currentUser.uid;
      this.projectPendings.splice(this.projectPendings.indexOf(project), 1);
      this.originalPendingsProjects.splice(this.originalPendingsProjects.indexOf(
        { id: project.id, name: project.name}), 1)
       // eslint-disable-next-line no-console
      console.log(project.id)

      firestore()
        .collection("User")
        .doc(idUser)
        .update({ projectsPending: this.originalPendingsProjects })
        // eslint-disable-next-line no-console
        .then(() => console.log("Informacion de usuario actualizada."));
      
      firestore()
        .collection("Project")
        .doc(proID)
        .get()
        .then(result => {
          const data = result.data();
          let pendingProjects = data.pendingContributors;
          let contributors = data.contributors;
          const filterObj = pendingProjects.filter(e => e.id !== idUser);

          firestore()
            .collection("User")
            .doc(idUser)
            .get()
            .then(result => {
              const data = result.data();
              contributors.push ({
                email: data.email.primary,
                full_name: data.full_name,
              });
              // eslint-disable-next-line no-console
              //console.log("AAAAAAAAAAA");
              firestore()
                .collection("Project")
                .doc(proID)
                .update({
                  contributors: contributors,
                  pendingContributors: filterObj
                })
                // eslint-disable-next-line no-console
                .then(() => console.log("Usuario agregado como contribuidor"));
                // eslint-disable-next-line no-console
                //console.log("BBBBBBBBBB");
            })
        }); 
    },
    changePage(project_id, validationOwner) {
      this.$router.push({
        path: `/dashboard/${project_id}/${validationOwner}`
      });
    },
    filterTag(tag) {
      if (tag.length > 0) {
        return tag.reduce((x, y) => {
          return x + ", " + y;
        });
      } else {
        return "";
      }
    },
    getCorrectList(page) {
      this.second_index = page * this.len_list;
      this.first_index = this.second_index - this.len_list;
    },
    changeLenList() {
      // eslint-disable-next-line no-unused-vars
      let project = [];

      if (this.active == 0) {
        project = [...this.getPublicsProjects];
      } else if (this.active == 1) {
        project = [...this.getPrivateProjects];
      } else {
        project = [...this.getRecommendedProjects];
      }

      this.page = 1;
      this.length_page = Math.ceil(project.length / this.len_list);
      this.getCorrectList(this.page);
    },
    orderList() {
      let projects;

      // eslint-disable-next-line no-console

      if (this.active == 0) {
        projects = [...this.getPublicsProjects];
      } else if (this.active == 1) {
        projects = [...this.getPrivateProjects];
      } else {
        projects = [...this.getRecommendedProjects];
      }
      //const arrayCopy = [...projects];
      const arrayCopy = [];

      projects.forEach(project => {
        let newProject = { ...project };

        if (newProject.milestones) { 
          const indice = newProject.milestones.length;
          let last_time = newProject.milestones[indice - 1].date;
          let date = new Date();
          let diff = last_time.toDate().getTime() - date.getTime();
          let dias;
          if (diff < 0) {
            dias = 0;
          } else {
            dias = Math.round(diff / (1000 * 60 * 60 * 24));
          }
          newProject.remainig_days = dias;
        } else {
          newProject.remainig_days = 0;
        }
        if (!project.type) {
          newProject.type = "OTHER";
        }
        arrayCopy.push(newProject);
      });

      if (this.order_by === "Título A-Z") {
        arrayCopy.sort((a, b) =>
          a.title > b.title ? 1 : b.title > a.title ? -1 : 0
        );
      } else if (this.order_by === "Título Z-A") {
        arrayCopy.sort((a, b) =>
          a.title < b.title ? 1 : b.title < a.title ? -1 : 0
        );
      } else if (this.order_by === "Propietario A-Z") {
        arrayCopy.sort((a, b) =>
          a.owner.full_name > b.owner.full_name
            ? 1
            : b.owner.full_name > a.owner.full_name
            ? -1
            : 0
        );
      } else if (this.order_by === "Propietario Z-A") {
        arrayCopy.sort((a, b) =>
          a.owner.full_name < b.owner.full_name
            ? 1
            : b.owner.full_name < a.owner.full_name
            ? -1
            : 0
        );
      } else if (this.order_by === "Tipo A-Z") {
        arrayCopy.sort((a, b) =>
          a.type > b.type ? 1 : b.type > a.type ? -1 : 0
        );
      } else if (this.order_by === "Tipo Z-A") {
        arrayCopy.sort((a, b) =>
          a.type < b.type ? 1 : b.type < a.type ? -1 : 0
        );
      }
      this.arrayOrder = arrayCopy;
      this.getCorrectList(this.page);
      this.changeLenList();
    },
    filterList() {
      let filter_array = [];

      if (this.arrayOrder)
        this.arrayOrder.filter(project => {
          if (this.filter_by == "Propietario") {
            let pos = project.owner.full_name
              .toLowerCase()
              .indexOf(this.search_value.toLowerCase());
            if (pos >= 0) filter_array.push(project);
          } else if (this.filter_by == "Título") {
            let pos = project.title
              .toLowerCase()
              .indexOf(this.search_value.toLowerCase());
            if (pos >= 0) filter_array.push(project);
          } else if (this.filter_by == "Tipo") {
            if (project.type) {
              let pos = project.type
                .toLowerCase()
                .indexOf(this.search_value.toLowerCase());
              if (pos >= 0) filter_array.push(project);
            }
          } else if (this.filter_by == "Etiquetas") {
            if (project.tags) {
              let pos = project.tags
                .toString()
                .toLowerCase()
                .indexOf(this.search_value.toLowerCase());
              if (pos >= 0) filter_array.push(project);
            }
          } else if (this.filter_by == "Dias Restantes") {
            let days = this.search_value;
            if (days == 0) {
              if (project.remainig_days == this.search_value)
                filter_array.push(project);
            } else {
              if (
                project.remainig_days <= this.search_value &&
                project.remainig_days > 0
              )
                filter_array.push(project);
            }
          } else if (this.filter_by == "Sin Filtro") {
            this.cleanFilter();
          }
        });
      this.arrayOrder = filter_array;
    },
    cleanFilter() {
      this.filter_by = "Sin Filtro";
      this.search_value = "";
      this.orderList();
    }
  }
};
</script>
